import AllexHero from '../components/Allex/AllexHero';
import AllexFeature from '../components/Allex/AllexFeature';

function Allex() {
  return (
    <div className="page allex-page">
      <AllexHero />
      <AllexFeature />
    </div>
  );
}

export default Allex;
